import { ShieldAlert, Wand2 } from "lucide-react";
import { Button } from "./ui/button";

// Under a view card: why this view holds the sculpt, and/or the advisory colour flags with "Redo with this fix".
export const ViewCheckNote = ({ view, block, flags, busy, onFix }) => {
  if (!block && !flags.length) return null;
  return (
    <div className="px-2 pb-2 space-y-2">
      {block && (
        <p data-testid={`view-block-${view}`} className="flex gap-1.5 text-xs leading-snug text-destructive font-semibold">
          <ShieldAlert className="h-3.5 w-3.5 mt-0.5 shrink-0" /> {block.reason}
        </p>
      )}
      {flags.length > 0 && (
        <div data-testid={`view-flags-${view}`} className="rounded-2xl border border-amber-500/40 bg-amber-500/10 p-2 space-y-1.5">
          {flags.map((f) => (
            <p key={`${f.colour}-${f.height}`} className="flex items-start gap-1.5 text-xs leading-snug">
              <span className="mt-0.5 h-3 w-3 shrink-0 rounded-full border border-border" style={{ background: f.colour }} />
              <span>
                Colour check: this {f.colour_name} part is not in the front view. You can still approve it.
              </span>
            </p>
          ))}
          <Button data-testid={`view-fix-${view}`} variant="outline" disabled={!!busy} onClick={onFix} className="w-full rounded-full h-9 gap-1.5 px-2 text-xs border-amber-500/50">
            <Wand2 className="h-3.5 w-3.5 shrink-0" /> Redo with this fix
          </Button>
        </div>
      )}
    </div>
  );
};
